import React, { useState } from "react";
import Label from "../grid/Label";
import Button from "../button/Button";
import {
  generateLoading,
  showAlert,
  stopLoading,
} from "../../promptMessages/PromptMessages";
import useUserLogin from "../../hooks/UserLoginhook";
import { UpdateQnARequestArray } from "../../lib/interfaces/AddQnAInterface";

interface Question {
  id: number;
  question: string;
}

interface SecretQuestionProps {
  questions?: UpdateQnARequestArray;
  userId: string;
  setIsOpen: any;
}

const SecretQuestion = ({
  questions,
  userId,
  setIsOpen,
}: SecretQuestionProps) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState<{ [key: number]: string }>({});
  const { customColor } = useUserLogin();
  const { handleValidateAnswer } = useUserLogin();

  // Safely access the current question
  const currentQuestion =
    questions && questions.length > 0 ? questions[currentQuestionIndex] : null;

  const handleChange = (value: string) => {
    if (currentQuestion) {
      setAnswers((prevAnswers) => ({
        ...prevAnswers,
        [currentQuestion.questionId]: value,
      }));
    }
  };
  const handleForgetPasswordButtonClick = async () => {
    if (questions) {
      let hasErrors = false; // Flag to track if any answer is incorrect

      for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        const questionFixId = question.questionId || 0;
        const answer = answers[questionFixId];
        const isLastQuestion = i === questions.length - 1;

        const isValid = await handleValidateAnswer(
          userId,
          questionFixId,
          answer,
          setIsOpen,
          isLastQuestion
        );

        // If the answer was incorrect, set the flag to true and break the loop
        if (!isValid) {
          hasErrors = true;
          break;
        }
      }

      // If there were errors, show the error alert
      if (hasErrors) {
        generateLoading("Please wait...");
        setTimeout(() => {
          stopLoading();
          showAlert("Invalid", "Incorrect Answer/s", "error", customColor);
        }, 1000);
      }
    }
  };

  return (
    <div className="flex flex-col gap-3.5 px-10">
      {currentQuestion ? (
        <>
          <Label
            key={currentQuestion.questionFixId}
            text={currentQuestion.question}
          />
          <input
            type="text"
            id={`question-${currentQuestion.questionId}`}
            value={answers[currentQuestion.questionId] || ""}
            onChange={(e) => handleChange(e.target.value)}
            className="mt-1 block w-full border border-gray-300 rounded-md p-2 h-10 text-black"
          />
          {questions && currentQuestionIndex === questions.length - 1 ? (
            <Button
              label="Submit"
              rounded
              onClick={handleForgetPasswordButtonClick}
              variant="btn-danger"
              customColor={customColor}
            />
          ) : (
            <Button
              label="Next"
              rounded
              variant="btn-danger"
              customColor={customColor}
              onClick={() => {
                if (questions) {
                  setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
                }
              }}
            />
          )}
        </>
      ) : (
        <Label text="No questions available" />
      )}
    </div>
  );
};

export default SecretQuestion;
